import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './scss/style.scss';

ReactDOM.render(
  <App />,
  document.getElementById('quiz')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/